import { rem } from 'polished'
import React from 'react'
import { DATA_TEST_CLASS } from 'shared-constants/build/testIds'
import styled from 'styled-components'
import { Image } from 'components/Image'
import { Flex } from 'components/Layout'
import Link from 'components/Link'

import { Text } from 'components/Typography'
import { ASPECT_RATIO } from 'components/UploadImage'
import { SCHEMA_PROPS, SCHEMA_TYPES } from 'constants/common'
import { COLOR_NAMES } from 'Theme'

const IMAGE_BASE_WIDTH = 300

export const DEFAULT_CARD_WIDTH = rem(178)

const StyledImage = styled(Image)`
  border-radius: 8px;
`

export const StrapiFeaturedCategoriesWidgetCard = ({
  index,
  image,
  url,
  name,
  width = DEFAULT_CARD_WIDTH,
}) => (
  <article itemScope itemType={SCHEMA_TYPES.LIST_ITEM}>
    <Flex width={width} maxWidth={width ?? DEFAULT_CARD_WIDTH}>
      <Link
        href={url}
        aria-label={`Visit products from ${name} category`}
        itemProp={SCHEMA_PROPS.URL}
      >
        <Flex
          data-test-class={DATA_TEST_CLASS.SHOWROOM_PRODUCT_CARD}
          position="relative"
          flexDirection="column"
          height="100%"
          width="100%"
          flexShrink={0}
        >
          <StyledImage
            alt={`${name} thumbnail`}
            objectFit="cover"
            aspectRatio={ASPECT_RATIO.PRODUCTS}
            src={image?.url}
            baseWidth={IMAGE_BASE_WIDTH}
            itemProp={SCHEMA_PROPS.IMAGE}
          />
          <Text
            fontSize={rem(16)}
            textAlign="center"
            color={COLOR_NAMES.EEIRE_BLACK}
            lineHeight="190%"
            mt={rem(12)}
          >
            {name}
          </Text>
        </Flex>
      </Link>
    </Flex>
    <meta itemProp={SCHEMA_PROPS.POSITION} content={index + 1} />
  </article>
)
